import { HomepageComponent } from './../components/homepage/homepage.component';
import { SlideDetailComponent } from './../components/homepage/slide-detail.component';
import { FileDetailComponent } from './../components/files/file-detail.component';
import { FileBrowseComponent } from './../shared/components/browse/file-browse.component';
import { HomeTileDetailComponent } from './../components/homepage/hometile-detail.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { AuthGuard } from './../shared/guards/auth.guard';

export const homepageRoutes = {
    path: 'homepage',
    data: {
        breadcrumbs: {
            label: 'Homepage',
            icon: 'homepage'
        },
        state: 'homepage'
    },
    children: [
        {
            path: '',
            component: HomepageComponent
        },
        {
            path: 'slides/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat snímek'
                },
                state: 'slide-add'
            },
            children: [
                {
                    path: '',
                    component: SlideDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'slides-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'slides-media-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'slides/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit dlaždici'
                },
                state: 'slide-edit'
            },
            children: [
                {
                    path: '',
                    component: SlideDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'slides-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'slides-media-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'hometiles/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat dlaždici'
                },
                state: 'hometile-add'
            },
            children: [
                {
                    path: '',
                    component: HomeTileDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'hometiles-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'hometiles-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'hometiles/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit snímek'
                },
                state: 'hometile-edit'
            },
            children: [
                {
                    path: '',
                    component: HomeTileDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'hometiles-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'hometiles-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat snímek'
                },
                state: 'slide-delete',
                apiUri: 'slides'
            },
            outlet: 'modal'
        },
        {
            path: 'hometiles-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat dlaždici'
                },
                state: 'hometile-delete',
                apiUri: 'home-tiles'
            },
            outlet: 'modal'
        }
    ],
    canActivate: [AuthGuard]
};
